import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GoogleCharts } from 'google-charts';
import { CovidService } from '../../covid.service';
import { Countries } from '../../interfaces/countries';

@Component({
  selector: 'app-articles-map',
  templateUrl: './articles-map.component.html',
  styleUrls: ['./articles-map.component.less']
})
export class ArticlesMapComponent implements OnInit {
  @Output() getLoading = new EventEmitter();
  worldCountries = null;
  loading = false;
  constructor(private covid: CovidService) { }

  ngOnInit(): void {
    this.getWorldCountries();
    this.loading = true;
  }

  getWorldCountries() {
    this.covid.getCovidCountries().subscribe(this.worldCountriesData.bind(this));
  }

  worldCountriesData(response) {
    this.worldCountries = response.map((item: Countries) => this.covid.formatCountries(item));
    this.worldCountries.unshift(['Country', 'Mentions']);
    this.covid.setMapData(this.worldCountries);
    this.loading = false;
    this.getLoading.emit(this.loading);
    this.drawMap();
  }

  drawMap() {
    GoogleCharts.load(() => {
      const map = document.getElementById('worldmap');
      const countries = GoogleCharts.api.visualization.arrayToDataTable(this.worldCountries);
      const countriesOptions = {
      colorAxis: {
        colors: ['#fce3d0', '#ff9800']
      },
      chartArea: {
        width: '80%',
        height: '90%'
      }
      };
      const countriesChart = new GoogleCharts.api.visualization.GeoChart(map);
      countriesChart.draw(countries, countriesOptions);
    });
  }

}
